module.exports = {
	"pagination": {
		"ListEventSourceMappings": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"limit_key": "MaxItems",
			"result_key": "EventSourceMappings"
		},
		"ListFunctions": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"limit_key": "MaxItems",
			"result_key": "Functions"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/lambda-2015-03-31.paginators.json
// module id = 717
// module chunks = 2